__turbopack_context__.v({
  "animateText": "STTextAnimationFlip-module__XR31oa__animateText",
  "animation": "STTextAnimationFlip-module__XR31oa__animation",
});
